import currencies from 'dibs-currency-helpers/exports/currencies';
import { PrerenderedCheckoutParams } from '../prerender/prerenderedCheckoutStore';

export type GetCheckoutUrlParams = {
    itemId: string;
} & PrerenderedCheckoutParams;

export const getCheckoutUrl = (params: GetCheckoutUrlParams): string => {
    const { itemId, ...otherParams } = params;
    const fakeBase = 'https://base'; // window.location.origin can't be used on ssr
    const url = new URL(`/checkout/id-${itemId}/`, fakeBase);

    let abtests;
    const currentAbtestsParam = new URLSearchParams(window.location.search).get('abtests');
    if (currentAbtestsParam) {
        abtests = currentAbtestsParam;
    }

    for (const [key, value] of Object.entries(otherParams)) {
        if (key === 'offerCurrency' && !currencies.includes(String(value))) {
            continue;
        }
        if (value) {
            url.searchParams.set(key, String(value));
        }
    }

    if (abtests) {
        url.searchParams.set('abtests', abtests);
    }

    return url.href.replace(fakeBase, '');
};
